import { createReducer } from 'redux-act';
import {
  failFetchingLoginState,
  fetchUser,
  failFetchingUser,
  initialUser,
  login,
  logout,
  externalSite,
  updateUser,
  failUpdateUser,
  successUpdateUser,
  updatePassword,
  reminderUpdatePassword,
  successReminderUpdatePassword,
} from '../actions/auth';
//[reducer] ../actions/{module_name}.jsで定義された内容を元に
//内部変数を変更する。
//component にて this.props.dispatch({actionName}());
//または
//redux-saga を使っている場合は ../saga/{module}.js から呼び出される。
//{actionName(param)} の引数param は props.dispatchで呼び出された場合は sagaに
// sagaで callによって呼び出されたときは reducer(このファイル)にて処理される。
//reducer を新規に作成した後は /reducer/index.js にも追記のこと。
//[actionName] :state =>
//[actionName] :(state,param) =>  ...{ationName(param)}
//[actionName] :() =>

//初期状態
const initial = {
  auth: {
    isPrepared: false,
    isLoggedIn: false,
    user: undefined,
    isFetching: false,
    error: undefined,
    jwt: '',
  },
};

const auth = createReducer(
  {
    [failFetchingLoginState]: state =>
      Object.assign({}, state, {
        isPrepared: true,
      }),
    [initialUser]: state =>
      Object.assign({}, state, {
        error: undefined,
      }),
    [fetchUser]: state =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [failFetchingUser]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [updatePassword]: state =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [reminderUpdatePassword]: state =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [successReminderUpdatePassword]: state =>
      Object.assign({}, state, {
        isFetching: false,
      }),
    [updateUser]: state =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [failUpdateUser]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successUpdateUser]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        user: Object.assign({}, state.user, payload),
        error: undefined,
      }),
    [externalSite]: (state, payload) => Object.assign({}, state),
    [login]: (state, payload) =>
      Object.assign({}, state, {
        isPrepared: true,
        isLoggedIn: true,
        user: payload,
        isFetching: false,
        error: undefined,
        jwt: payload.jwt,
      }),
    [logout]: () =>
      Object.assign({}, initial.auth, {
        isPrepared: true,
      }),
  },
  initial.auth
);

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/auth.js